import { useReducer } from 'react';
import { createContainer } from 'react-tracked';

import rootReducer, { initialState } from './reducers';

const useValue = () => useReducer(rootReducer, initialState);

export const { Provider, useTrackedState, useUpdate: useDispatch } = createContainer(useValue);
